export const getShouldShowInvoiceImages = (storeId: string): boolean => {
  const listOfIds = process.env.REACT_APP_SHOW_INVOICE_IMAGES || '';
  const arrayOfIds = listOfIds.split(',');
  return arrayOfIds.includes(storeId);
};
